import { memo } from 'react';

const Title = memo(({ title }) => <h3 className="h3 sf__h1">{title}</h3>);

export default Title;
